<template>
  <list :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <filter-by-status-header
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Hỗ trợ yêu cầu'"
            @filterByStatus="filterByStatus"
          />
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="openCreateDialog"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <search
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                </search>
              </template>
            </sub-header>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt padding-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left padding-left-10"
                    @click="doSort('title')"
                  >
                    Tên yêu cầu
                    <sort-caret :order="order" :sort="sort" :field="'title'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left padding-left-10"
                    @click="doSort('deptName')"
                  >
                    Đơn vị yêu cầu
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'deptName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-left-10"
                    @click="doSort('total')"
                  >
                    Tổng tiền
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'total'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-left-10"
                    @click="doSort('status')"
                  >
                    Trạng thái
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'status'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <vue-perfect-scrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in items"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left clickable">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="theTitle__lv1 margin-right-10 padding-left-10"
                      >
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.title }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv1 flex-row flex__right padding-left-10 font-size__small"
                      >
                        <div class="flex-row">
                          {{ item.deptName || "-" }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row">
                          {{ item.total || "-" }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <el-tag
                            size="mini"
                            :class="['priority',getStatusCssClasses(item.status)]"
                          >{{getStatusLabel(item.status)}}
                          </el-tag>
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không tìm thấy kết quả nào</div>
                  </infinite-loading>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </template>
        </list>
      </div>

      <vanphongpham-create-dialog
        :isOpen="isOpenDialogCreate"
        :id="selectedId"
        :mode="'approveMode'"
        v-if="isEnableDialogCreate"
        @closeDialog="isOpenDialogCreate = false"
        @closed="isEnableDialogCreate = false"
        @success="createSuccess"
      />
    </template>
  </list>
</template>

<script>
  import List from "../../common/list";
  import MainHeader from "../../../components/header/main-header";
  import SubHeader from "../../../components/main/sub-header";
  import Search from "../../common/noAdvSearch";
  import SortCaret from "../../doc-out/SortCaret";
  import dateFormatter from "../../../filters/dateFormatter";
  import FilterByStatusHeader from "../../doc-out/components/filter-by-status-header";
  import vanphongphamService from "../../../services/vanphongphamService";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import VanphongphamCreateDialog from "./vanphongpham-create-dialog";

  export default {
    name: "vanphongpham-index",
    components: {
      VanphongphamCreateDialog,
      FilterByStatusHeader,
      SortCaret,
      Search,
      SubHeader,
      MainHeader,
      List,
      VuePerfectScrollbar
    },
    filters: {dateFormatter},
    data() {
      return {
        selectedId: null,
        isOpenDialogCreate: false,
        isEnableDialogCreate: false,
        isOpenAdvanceSearchDialog: false,
        keyword: null,
        order: null,
        sort: null,
        page: 0,
        size: 10,
        items: [],
        filterOptions: [],
        filterStatus: null
      };
    },

    watch: {
      isOpenDialogCreate(newValue) {
        if (newValue) {
          this.isEnableDialogCreate = newValue
        } else {
          this.selectedId = null;
        }
      }
    },

    created() {
      this.initPage();
      this.initQuery();
    },

    methods: {

      getStatusCssClasses(status) {
        switch (status) {
          case "approved":
            return "lv4";
          case "waitForApproving":
            return "lv2";
          default:
            return "";
        }
      },

      getStatusLabel(status) {
        switch (status) {
          case "approved":
            return "Đã duyệt";
          case "waitForApproving":
            return "Chờ duyệt";
          default:
            return "-";
        }
      },

      openCreateDialog() {
        console.log("openCreateDialog");
        this.isOpenDialogCreate = true;
      },

      createSuccess() {
        console.log("createSuccess");
        this.isOpenDialogCreate = false;
        this.doSearch();
      },

      initQuery() {
        this.sort = this.$route.query.sort || "updateTime";
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          query: this.$route.query.query || undefined,
          status: this.$route.query.status || "waitForApproving"
        };
        this.filterStatus = this.advanceSearchForm.status;
        this.keyword = this.advanceSearchForm.query;
      },

      simpleSearch(keyword) {
        this.advanceSearchForm.query = keyword;
        this.keyword = this.advanceSearchForm.query;
        this.doSearch();
      },

      doSort(sort) {
        let order =
          sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
        this.sort = sort;
        this.order = order;
        this.doSearch();
      },

      initPage() {
        this.filterOptions = [
          {
            label: "Chờ phê duyệt",
            value: "waitForApproving",
            iconClass: "fa-clock"
          },
          {
            label: "Đã phê duyệt",
            value: "approved",
            iconClass: "fa-check"
          }
        ];
      },

      doSearch() {
        this.$router.replace({
          name: this.$router.name,
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.items = [];
        this.page = 0;
        this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
      },

      buildQuery() {
        return {
          query: this.advanceSearchForm.query || undefined,
          status: this.advanceSearchForm.status || undefined
        };
      },

      list() {
        let pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
        return vanphongphamService
          .findAll(this.advanceSearchForm, pageable)
          .then(response => {
            let items = response.data;
            items && this.items.push(...items);
            return items;
          });
      },

      viewDetail(item) {
        this.selectedId = item.id;
        this.isOpenDialogCreate = true;
      },

      filterByStatus(event) {
        this.advanceSearchForm.status = event.filterStatus;
        this.advanceSearchForm.query = null;
        this.filterStatus = this.advanceSearchForm.status;
        this.keyword = this.advanceSearchForm.query;
        this.doSearch();
      },

      infiniteHandler(state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? state.loaded() : state.complete();
        });
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vanphongpham/vanphongpham-index.vue